(function(){
  var r=document.documentElement,t=document.getElementById('tt');
  /* Guarded: this is a multi-page storefront now, and a null #tt used to throw
     a TypeError that killed every script below it on that page. */
  if(t){
    t.addEventListener('click',function(){
      var c=r.getAttribute('data-theme');
      if(!c){c=matchMedia('(prefers-color-scheme:dark)').matches?'dark':'light';}
      var next=c==='dark'?'light':'dark';
      r.setAttribute('data-theme',next);
      /* Persist, or the choice resets on every navigation. Read back in <head>
         before first paint so there is no flash of the wrong palette. */
      try{localStorage.setItem('gc-theme',next);}catch(e){}
    });
  }
  /* The LCD screen-driver went with the CSS-drawn calculator (git history has
     both) — the hero and features now stage the device renders instead. */

  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.16});
  document.querySelectorAll('.reveal').forEach(function(n){io.observe(n);});

  /* directional scroll reveals — halves of each two-column block slide in from
     opposite sides, alternating per section (Elisey's ltr/rtl pattern) */
  document.querySelectorAll('.two').forEach(function(row,i){
    var kids=row.children;
    if(kids.length<2)return;
    var flip=i%2===1;
    /* skip the parallax wrapper — .rv would overwrite its transform */
    if(!kids[0].classList.contains('px'))kids[0].classList.add('rv',flip?'r':'l');
    if(!kids[1].classList.contains('px'))kids[1].classList.add('rv',flip?'l':'r');
  });
  document.querySelectorAll('.sec-head + h2, .three, .work').forEach(function(n){
    if(!n.classList.contains('rv'))n.classList.add('rv','u');
  });
  var rio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');rio.unobserve(e.target);}});},{threshold:.12});
  document.querySelectorAll('.rv').forEach(function(n){rio.observe(n);});

  /* hero device parallax — rises slower than the page, like his feature-scroll */
  var px=document.getElementById('px'),ticking=false;
  function park(){
    /* measure the parent, not the moving element, or the transform feeds back */
    var r=px.parentElement.getBoundingClientRect(), vh=window.innerHeight||800;
    var prog=(vh/2-(r.top+r.height/2))/vh;          /* roughly −0.5 … 0.5 */
    px.style.setProperty('--py',(prog*44).toFixed(1)+'px');
    ticking=false;
  }
  /* Guarded like #tt above: #px only exists on the homepage, and an unguarded
     park() threw on product/cart pages, killing every handler below it. */
  if(px){
    park();
    if(!matchMedia('(prefers-reduced-motion:reduce)').matches){
      window.addEventListener('scroll',function(){
        if(!ticking){requestAnimationFrame(park);ticking=true;}
      },{passive:true});
    }
  }

  /* Waitlist: fold the optional country choice into the tags field on submit
     ("waitlist,country:DE"). The select has no name attribute on purpose — with
     JS off it simply contributes nothing and the signup still works. Choosing
     "Somewhere else" reveals a free-text country field (posted as the customer
     note) whose value is also folded in as country_other:<slug>. */
  document.addEventListener('change',function(e){
    var sel=e.target;if(!sel.hasAttribute||!sel.hasAttribute('data-waitlist-country'))return;
    var f=sel.form,other=f&&f.querySelector('[data-waitlist-other]');if(!other)return;
    var show=sel.value==='XX';other.classList.toggle('on',show);other.required=show;other.disabled=!show;
    if(show){other.focus();}else{other.value='';}
  },true);
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f.classList||!f.classList.contains('waitlist-form'))return;
    var sel=f.querySelector('[data-waitlist-country]'),tags=f.querySelector('[data-waitlist-tags]'),other=f.querySelector('[data-waitlist-other]');
    if(!sel||!tags)return;
    var v='waitlist';
    if(sel.value){v+=',country:'+sel.value;}
    if(sel.value==='XX'&&other&&other.value.trim()){
      var slug=other.value.trim().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'').slice(0,40);
      if(slug){v+=',country_other:'+slug;}
      other.value='Waitlist country: '+other.value.trim();
    }else if(other){other.disabled=true;}
    tags.value=v;
  },true);

  var w=document.getElementById('work');
  var wo=new IntersectionObserver(function(es){es.forEach(function(e){
    if(!e.isIntersecting)return;wo.unobserve(e.target);
    e.target.querySelectorAll('.step').forEach(function(s,i){setTimeout(function(){s.classList.add('on');},i*620);});
  });},{threshold:.35});
  if(w)wo.observe(w);

})();

